import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLandmark as faLandmarkRegular } from '@fortawesome/pro-regular-svg-icons';
import BreadCrumbs from './BreadCrumbs';
import HeaderComponent from './HeaderComponent';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import TransactionDetails from "../assets/images/transaction_details.svg";
import EntityOverview from "../assets/images/entity_overview.svg";
import DQIDashboard from "../assets/images/dqi_dashboard.svg";
import FDDDashboard from "../assets/images/fdd.svg";
import CaresDashboard from "../assets/images/cares_dashboard.svg";
import ARPADashboard from "../assets/images/arpa_dashboard.svg";
import VendorSearch from "../assets/images/vendor_search.svg";
import HighestPaidVendors from "../assets/images/highest_paid_vendors.svg";
import '../assets/styles/main.css';

const EntityPages = () => {
  return (
    <div className="entity-pages" id="entity-pages">
      <HeaderComponent/>
      <FeatureNav />
      <BreadCrumbs/>
      <main className="mt-20">
        <div className="text-center mb-4">
          <h1 className="display-5 fw-bold mb-3">Entities</h1>
        </div>

        <section className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 shadow px-0" style={{ backgroundColor: "var(--tu-teal)"}}>
          <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px"}}>
            <h2 className="text-light" style={{ fontSize: "1.5rem", textTransform: "none" }}> 
              <FontAwesomeIcon icon={faLandmarkRegular} className="me-2" /> 
              Entity
            </h2>
            <p className="lead">
              Use these tools to learn about governmental entity revenue, expenditure, and compliance
            </p>
          </div>

          <div className="col-12 bg-light">
            <div className="row justify-content-center px-3">
              {/* Transaction Details */}
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer"  href="https://old.transparent.utah.gov/transaction_details.php" title="Transaction Details">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Transaction Details</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={TransactionDetails} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Inspect an Entity's transactions</p>
                  </div>
                </a>
              </article>

              {/* Entity Overview */}
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                  rel="noopener noreferrer" href="/entities/entity-overview-dashboard" title="Entity Overview Dashboard">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Entity Overview</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityOverview} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Investigate an Entity's revenue and expenditure</p>
                  </div>
                </a>
              </article>

              {/* Data Quality Dashboard */}
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/dqi_dashboard.php" title="Data Quality Dashboard">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Data Quality Dashboard</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={DQIDashboard} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Examine the quality of the data submitted to Transparent Utah</p>
                  </div>
                </a>
              </article>

              {/* Fiscal Distress Dashboard */}
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/fdd.php" title="Fiscal Distress Dashboard">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Fiscal Distress Dashboard</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={FDDDashboard} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Analyze an entity's fiscal distress indicators</p>
                  </div>
                </a>
              </article>

              {/* CARES Dashboard */}
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/cares_dashboard.php" title="CARES Dashboard">
                  <div className="card-header text-center text-white bg-blue400" style={{ backgroundColor: "var(--tu-teal)"}}>CARES Dashboard</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={CaresDashboard} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Explore a detailed CARES dashboard</p>
                  </div>
                </a>
              </article>

              {/* ARPA Dashboard */}
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/arpa_dashboard.php" title="ARPA Dashboard">
                  <div className="card-header text-center text-white bg-blue400" style={{ backgroundColor: "var(--tu-teal)"}}>ARPA Dashboard</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={ARPADashboard} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Explore a detailed ARPA dashboard</p>
                  </div>
                </a>
              </article>

              {/* Vendor Payment Search */}
              <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer" href="/entities/vendor-payments-search" title="Vendors Payments">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Vendor Payment Search</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={VendorSearch} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Search for a vendor's payments</p>
                  </div>
                </a>
              </article>

              {/* Highest Paid Vendors */}
            <article className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/ven.php" title="Highest Paid Vendors">
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Highest Paid Vendors</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={HighestPaidVendors} />
                  <div className="card-body py-0">
                    <p className="card-text text-center">Examine an entity's highest paid vendors</p>
                  </div>
                </a>
              </article>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  )
}

export default EntityPages;